import React, { Fragment } from 'react';

import { Container, Heading, Text } from '@lglp/components';
import { Link as LinkHelper } from 'prismic-helpers';
import PrismicRichText, { Elements } from 'prismic-richtext';
import { compose, concat, equals, prop, toLower } from 'ramda';

import Link from '../../components/library/Link';
import { toDocType } from '../../schema/prismic/mapping';
import { LinkType } from '../../types';
import { getUrlFromDocument } from '../routes/mapping';

const CLASS_NAME = 'generated';

const serializeStandardTag = (tag, props, children) => (
  <Container as={tag} {...props}>
    {children}
  </Container>
);

const serializeText = (props, children) => <Text {...props} body={children} />;

const serializeHeading = (tag, props, children) => (
  <Heading as={tag} {...props}>
    {children}
  </Heading>
);

const serializeHyperlink = (props, linkResolver, { data } = {}, children) => {
  const type = compose(concat('link-'), toLower, prop('link_type'))(data);
  let link = LinkHelper.url(data, linkResolver);

  if (equals(type, LinkType.LINK_TYPE_MEDIA)) {
    props.download = true;
  }

  if (equals(type, LinkType.LINK_TYPE_DOC)) {
    link = getUrlFromDocument({
      ...data,
      linkType: type,
      type: toDocType(data.type),
    });
  }

  return (
    <Link {...props} href={link}>
      {children}
    </Link>
  );
};

const serializeSpan = (content) => (content ? content : '');

const serialize = (linkResolver, type, element, content, children, index) => {
  const props = {
    className: [CLASS_NAME, element.label].filter(Boolean).join(' '),
    key: index,
  };

  switch (type) {
    case Elements.heading1:
      return serializeHeading('h1', props, children);
    case Elements.heading2:
      return serializeHeading('h2', props, children);
    case Elements.heading3:
      return serializeHeading('h3', props, children);
    case Elements.heading4:
      return serializeHeading('h4', props, children);
    case Elements.heading5:
      return serializeHeading('h5', props, children);
    case Elements.heading6:
      return serializeHeading('h6', props, children);
    case Elements.paragraph:
      return serializeText(props, children);
    case Elements.strong:
      return serializeStandardTag('strong', props, children);
    case Elements.em:
      return serializeStandardTag('em', props, children);
    case Elements.listItem:
      return serializeStandardTag(
        'li',
        { ...props, className: `${props.className} list-element-item` },
        children
      );
    case Elements.oListItem:
      return serializeStandardTag('li', props, children);
    case Elements.list:
      return serializeStandardTag(
        'ul',
        { ...props, className: `${props.className} list-element` },
        children
      );
    case Elements.oList:
      return serializeStandardTag('ol', props, children);
    case Elements.hyperlink:
      return serializeHyperlink(props, linkResolver, element, children);
    case Elements.label:
      return serializeStandardTag('span', props, children);
    case Elements.span:
      return serializeSpan(content);
    case Elements.image:
    case Elements.embed:
    default:
      return null;
  }
};

/**
 * @deprecated
 */
export const asHtml = (richText, linkResolver, htmlSerializer) => {
  const serializedChildren = PrismicRichText.serialize(
    richText,
    serialize.bind(null, linkResolver),
    htmlSerializer
  );
  return <Fragment>{serializedChildren}</Fragment>;
};
